<template>
    <SettingsLocations :client="client" @updated="onSetupComplete"/>
</template>

 <script>
    import SettingsLocations from '@/pages/client/Settings/Locations'

    export default {
        props: ['client', 'setupStatus'],
        components: {SettingsLocations},
        data() {
            return {}
        },
        methods: {
            onSetupComplete() {
                this.$store.dispatch('START_LOADING')
                this.$api.post(`/clients/${this.client.id}/setup-status`, {step: 'locations'}).then(resp => {
                    this.$store.dispatch('STOP_LOADING')
                    this.$emit('refreshClient')
                }).catch((errors) => {
                    this.$store.dispatch('STOP_LOADING')
                    this.$bus.showError(errors.__all__)
                })
            },
        },
    }
    </script>
